import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getFromLocalStorage } from "../../utils";
import { LocalStorageEnum } from "../../utils/localstorage/LocalStorageEnum";
import isTokenExpired from "../../helpers/isTokenExpired";
import envconf from "../../envConfig";
import { UserContext } from "../context/userContext";

interface ProtectedOutProps {
  children: JSX.Element;
}

const ProtectedOut: React.FC<ProtectedOutProps> = ({ children }) => {
  const token = getFromLocalStorage(LocalStorageEnum.TOKEN);
    const { doLogout } = useContext(UserContext);
  

  // Skip auth logic in dev mode
  if (envconf?.IS_DEV) {
    return children;
  }

  const isAuthenticated = token && !isTokenExpired(token);
  

  if (!isAuthenticated) {
    toast.error("Session expired, you will be disconnected!");
    doLogout()
  }

  return children;
};

export default ProtectedOut;
